import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Tag extends React.Component {
  constructor(props) {
    super(props)
    this.config = {
      types: [
        { 
          title: 'highlight',
          isDefault: true
        },
        'feedback',
        'hat',
        'category'
      ],
      modifiers : [
        'inverse'
      ],
      states : []
    }
  }

  render() {
    const { 
      highlight,
      feedback,
      hat,
      category,
      inverse,
      children, 
      ...rest
    } = this.props
    return  <div {...rest} className={resolveProps(this.props, this.config, 'Tag') }>
      {feedback && <span className="mdn-Tag-icon mdn-Icon-informacoes mdn-Icon--sm" />}
      <p>{children}</p>
    </div>
  }
}

Tag.propTypes = {
  feedback : PropTypes.bool,
  children : PropTypes.node,
  etc: PropTypes.object
}